import ApiService from "./api.service";

export const UserService = {
    create(params) {
        return ApiService.post("users", { params });
    },
    update(id, params) {
        return ApiService.update("users", id, params);
    },
    updatePermissions(id, params) {
        return ApiService.update("users/permissions", id, params);
    },
    get(id) {
        return ApiService.get("users", id);
    },
    list() {
        return ApiService.query("/users/options");
    }
};
